import { UserTypes } from "shared-types";
import { getUserAttribute, UserAttributes } from "../services/authorization";

/**
 * Checks if the user is a filmmakers profile based on the publication code.
 * @param artistType - The artist type to check. Get from viewPin for public profile view.
 * Otherwise, get from publication code inside JWT claims.
 *
 * @returns True if the user is a filmmakers profile, false otherwise.
 */

export function checkIsFilmmakersProfile(artistType?: UserTypes) {
  const value =
    artistType !== undefined && artistType !== null
      ? Number(artistType)
      : Number(getUserAttribute(UserAttributes.PublicationCode));

  if (Number.isNaN(value)) {
    return false;
  }

  return value === UserTypes.filmmakersProfile;
}
